import React from 'react';

import './CookieConsentModal.css'; // 引入樣式

import Cookies from 'js-cookie';
import { useState, useEffect } from 'react';
import { getCookieToken } from '../../constants';

const CookieConsentModal = () => {

  // 設定cookie的原碼;
  const [cookieConsent, setCookieConsent] = useState(Cookies.get('cookieConsent'));
  const [showModal, setShowModal] = useState(!cookieConsent);

  useEffect(() => {
    if (cookieConsent === 'accepted') {

      const checkToken = async () => {

        let token = await getCookieToken();        
        console.log("CookieConsentModal CALL Token check! token:", token);
        // console.log('Cookies 被接受, token:', token);
        //console.log(token);
        return token;
      }
      
      checkToken();
    
    }
  }, [cookieConsent]);



  const handleAccept = () => {
    Cookies.set('cookieConsent', 'accepted', { expires: 365 });
    setCookieConsent('accepted');
  };

  const handleReject = () => {
    console.log('Cookies 被拒絕');
    setShowModal(false);
  };

  if (cookieConsent) {

    return null;

  } else if (!showModal) {

    // 沒有接受Cookies，並且已經關閉詢問彈窗
    //沒用Cookie的路線暫時不處理
  
    return null;
  }

  return (
    <div className="cookie-consent-modal" onClick={handleReject}>
      <div className="cookie-consent-content" onClick={e => e.stopPropagation()}>
        <h2>Cookie 同意</h2>
        <p>我們使用 cookies 來增強您的體驗。繼續訪問本網站即表示您同意我們使用 cookies。</p>
        <button className="acceptButton" onClick={handleAccept}>接受</button>
        <button className="acceptButton" onClick={handleReject}>拒絕</button>
      </div>
    </div>
  );
};

export default CookieConsentModal;
